import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { initSentry } from './observability/sentry';
import { AppError } from './observability/AppError';

// Start error tracking before the app mounts (D-hardening-sentry). Gated on the DSN, so this
// is a clean no-op in dev and CI where no DSN is set.
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

// ONE top-level boundary is the capture floor: every unhandled render error reaches Sentry
// and the user sees a graceful fallback. Per-surface boundaries are deferred (a UX
// refinement, not a coverage gap). It composes with React Admin's own error handling: the
// outer boundary reports and renders its fallback, React Admin's internal handling is
// unaffected.
createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<AppError />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
